import axios from 'axios';

let userData = {};
const USER_URI = `/api/bff-user/private/user`;

export const getUserService = token => {

  if(Object.keys(userData).length > 0) return Promise.resolve(userData);

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  };

  return axios.get(USER_URI, headers).then( (data) => {
    userData = data;
    return userData;
  });
};